// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css/lib/js/src/Css.js");
var Link = require("./link");
var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Fetch = require("bs-fetch/lib/js/src/Fetch.js");
var Theme = require("./theme");
var React = require("react");
var Network = require("./network");
var Json_encode = require("@glennsl/bs-json/lib/js/src/Json_encode.bs.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");
var Mail_inputSvg = require("./assets/mail_input.svg");
var Password_resetSvg = require("./assets/password_reset.svg");

var card = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* [] */0
      ]
    ]);

var reset = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.width(/* `percent */[
                    -119887163,
                    100.0
                  ]),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var resetHeadBox = Css.style(/* :: */[
      Css.position(Css.relative),
      /* :: */[
        Css.textAlign(Css.center),
        /* :: */[
          Css.display(Css.flexBox),
          /* :: */[
            Css.flexDirection(Css.column),
            /* :: */[
              Css.alignItems(Css.center),
              /* :: */[
                Css.flexDirection(Css.column),
                /* :: */[
                  Css.margin4(Css.px(20), Css.px(0), Css.px(0), Css.px(0)),
                  /* :: */[
                    Css.fontSize(Css.px(24)),
                    /* :: */[
                      Css.width(Css.px(110)),
                      /* :: */[
                        Css.height(Css.px(110)),
                        /* :: */[
                          Css.borderRadius(/* `percent */[
                                -119887163,
                                50.0
                              ]),
                          /* :: */[
                            Css.boxShadow(/* Some */[Css.px(1)], /* Some */[Css.px(1)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(244, 48, 134, 0.15)),
                            /* [] */0
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var resetIcon = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(0)),
      /* :: */[
        Css.transforms(/* :: */[
              /* `scale */[
                -120664438,
                /* tuple */[
                  1.1,
                  1.1
                ]
              ],
              /* :: */[
                /* `translate */[
                  -914368690,
                  /* tuple */[
                    /* `percent */[
                      -119887163,
                      -50.0
                    ],
                    Css.px(0)
                  ]
                ],
                /* [] */0
              ]
            ]),
        /* :: */[
          Css.position(/* absolute */-1013592457),
          /* :: */[
            Css.left(/* `percent */[
                  -119887163,
                  52.0
                ]),
            /* :: */[
              Css.zIndex(2),
              /* :: */[
                Css.top(Css.px(35)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var resetText = Css.style(/* :: */[
      Css.padding(Css.px(10)),
      /* :: */[
        Css.textAlign(/* center */98248149),
        /* :: */[
          Css.color(/* `hex */[
                5194459,
                "F66297"
              ]),
          /* [] */0
        ]
      ]
    ]);

var inputBox = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.width(/* `percent */[
                    -119887163,
                    100.0
                  ]),
              /* :: */[
                Css.padding(Css.px(10)),
                /* :: */[
                  Css.boxSizing(/* borderBox */9307263),
                  /* :: */[
                    Css.position(Css.relative),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var inputFieldBox = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.position(Css.relative),
            /* :: */[
              Css.boxSizing(/* borderBox */9307263),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding4(Css.px(5), Css.px(10), Css.px(5), Css.px(50)),
        /* :: */[
          Css.fontSize(Css.px(18)),
          /* :: */[
            Css.minHeight(Css.px(40)),
            /* :: */[
              Css.maxWidth(Css.px(300)),
              /* :: */[
                Css.width(/* `percent */[
                      -119887163,
                      100.0
                    ]),
                /* :: */[
                  Css.minWidth(Css.px(220)),
                  /* :: */[
                    Css.borderRadius(/* `px */[
                          25096,
                          50
                        ]),
                    /* :: */[
                      Css.border(Css.px(1), /* solid */12956715, /* `hex */[
                            5194459,
                            "F492BD"
                          ]),
                      /* :: */[
                        Css.boxShadow(/* Some */[Css.px(1)], /* Some */[Css.px(1)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(244, 48, 134, 0.15)),
                        /* :: */[
                          Css.boxSizing(/* borderBox */9307263),
                          /* :: */[
                            Css.position(Css.relative),
                            /* [] */0
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var mailInput = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(0)),
      /* :: */[
        Css.transforms(/* :: */[
              /* `scale */[
                -120664438,
                /* tuple */[
                  1.2,
                  1.2
                ]
              ],
              /* :: */[
                /* `translate */[
                  -914368690,
                  /* tuple */[
                    /* `percent */[
                      -119887163,
                      0.0
                    ],
                    Css.px(0)
                  ]
                ],
                /* [] */0
              ]
            ]),
        /* :: */[
          Css.left(Css.px(18)),
          /* :: */[
            Css.position(/* absolute */-1013592457),
            /* :: */[
              Css.zIndex(2),
              /* :: */[
                Css.top(Css.px(25)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var someLink = Css.style(/* :: */[
      Css.fontSize(Theme.smallFontSize),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.margin2(Css.px(5), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

var Styles = /* module */[
  /* card */card,
  /* reset */reset,
  /* resetHeadBox */resetHeadBox,
  /* resetIcon */resetIcon,
  /* resetText */resetText,
  /* inputBox */inputBox,
  /* inputFieldBox */inputFieldBox,
  /* inputField */inputField,
  /* mailInput */mailInput,
  /* someLink */someLink
];

function text(prim) {
  return prim;
}

function validateEmail(value) {
  var emailRegex = (/.*@.*\..+/);
  if (value === "") {
    return /* Some */["Email Feld leer"];
  } else if (emailRegex.test(value)) {
    return /* None */0;
  } else {
    return /* Some */["Email Adresse enthält Fehler"];
  }
}

function showApiError(data, self, message) {
  return Promise.resolve(data).then((function () {
                  console.log("Login error!");
                  Curry._1(self[/* send */4], /* ShowErrorMessage */Block.__(1, [message]));
                  return Promise.resolve(/* () */0);
                })).catch((function (err) {
                return Promise.resolve((console.log("API error exception", err), /* () */0));
              }));
}

var component = ReasonReact.reducerComponent("Reset");

function make() {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function (param) {
      var send = param[/* send */4];
      var state = param[/* state */2];
      var match = state[/* error */1];
      var match$1 = state[/* success */2];
      var match$2 = state[/* loading */3];
      return React.createElement("div", {
                  className: reset
                }, React.createElement("div", {
                      className: resetHeadBox
                    }, React.createElement("img", {
                          className: resetIcon,
                          alt: "icon",
                          src: Password_resetSvg
                        })), React.createElement("h1", undefined, "Passwort Reset"), React.createElement("div", {
                      className: resetText
                    }, "Bitte gebe zum Reset deines Passworts deine Email Adresse ein. Wir senden dir einen Reset Link zu."), React.createElement("div", {
                      className: inputBox
                    }, React.createElement("div", {
                          className: inputFieldBox
                        }, React.createElement("input", {
                              className: inputField,
                              autoFocus: true,
                              placeholder: "Email",
                              type: "email",
                              value: state[/* email */0],
                              onKeyDown: (function ($$event) {
                                  if ($$event.keyCode === 13) {
                                    $$event.preventDefault();
                                    return Curry._1(send, /* ResetEnterKeyDown */1);
                                  } else {
                                    return Curry._1(send, /* ResetOtherKeyDown */0);
                                  }
                                }),
                              onChange: (function ($$event) {
                                  return Curry._1(send, /* ChangeEmail */Block.__(0, [$$event.target.value]));
                                })
                            }), React.createElement("img", {
                              className: mailInput,
                              alt: "mail",
                              src: Mail_inputSvg
                            }))), match ? React.createElement("div", {
                        className: "failure"
                      }, match[0]) : null, match$1 ? React.createElement("div", {
                        className: "success"
                      }, match$1[0]) : null, React.createElement("button", {
                      className: Theme.simpleButton(/* () */0),
                      onClick: (function () {
                          return Curry._1(send, /* Reset */2);
                        })
                    }, match$2 !== 0 ? React.createElement("div", {
                            className: "button-spinner"
                          }) : "Absenden"), ReasonReact.element(/* None */0, /* None */0, Link.make("/login", "zum Login", someLink, /* array */[])));
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* email */"",
              /* error : None */0,
              /* success : None */0,
              /* loading : false */0
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      if (typeof action === "number") {
        switch (action) {
          case 0 : 
              return /* NoUpdate */0;
          case 1 : 
              return /* SideEffects */Block.__(2, [(function (self) {
                            return Curry._1(self[/* send */4], /* Reset */2);
                          })]);
          case 2 : 
              var emailValid = validateEmail(state[/* email */0]);
              if (emailValid) {
                var error = emailValid[0];
                return /* SideEffects */Block.__(2, [(function (self) {
                              return Curry._1(self[/* send */4], /* ShowErrorMessage */Block.__(1, [error]));
                            })]);
              } else {
                return /* UpdateWithSideEffects */Block.__(3, [
                          /* record */[
                            /* email */state[/* email */0],
                            /* error */state[/* error */1],
                            /* success */state[/* success */2],
                            /* loading : true */1
                          ],
                          (function (self) {
                              var requestPayload = Json_encode.object_(/* :: */[
                                    /* tuple */[
                                      "email",
                                      self[/* state */2][/* email */0]
                                    ],
                                    /* [] */0
                                  ]);
                              fetch(Network.resetUrl, Fetch.RequestInit[/* make */0](/* Some */[/* Post */2], /* Some */[{
                                                "Content-Type": "application/json",
                                                Accept: "application.json"
                                              }], /* Some */[JSON.stringify(requestPayload)], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0)(/* () */0)).then((function (data) {
                                        var statusCode = data.status;
                                        console.log("https status: ", statusCode);
                                        if (statusCode !== 201) {
                                          return showApiError(data, self, "Http Fehler: " + String(statusCode));
                                        } else {
                                          console.log("Reset initiated");
                                          Curry._1(self[/* send */4], /* ShowSuccessMessage */Block.__(2, ["Wir haben dir eine Email gesendet. Bitte prüfe deinen Posteingang."]));
                                          return Promise.resolve(/* () */0);
                                        }
                                      })).catch((function (err) {
                                      return Promise.resolve((console.log("Api error", err), Curry._1(self[/* send */4], /* ShowErrorMessage */Block.__(1, ["Netzwerkfehler"]))));
                                    }));
                              return /* () */0;
                            })
                        ]);
              }
          case 3 : 
              return /* Update */Block.__(0, [/* record */[
                          /* email */state[/* email */0],
                          /* error : None */0,
                          /* success */state[/* success */2],
                          /* loading */state[/* loading */3]
                        ]]);
          case 4 : 
              return /* Update */Block.__(0, [/* record */[
                          /* email */state[/* email */0],
                          /* error */state[/* error */1],
                          /* success : None */0,
                          /* loading */state[/* loading */3]
                        ]]);
          
        }
      } else {
        switch (action.tag | 0) {
          case 0 : 
              return /* Update */Block.__(0, [/* record */[
                          /* email */action[0],
                          /* error */state[/* error */1],
                          /* success */state[/* success */2],
                          /* loading */state[/* loading */3]
                        ]]);
          case 1 : 
              var text = action[0];
              return /* UpdateWithSideEffects */Block.__(3, [
                        /* record */[
                          /* email */state[/* email */0],
                          /* error : Some */[text],
                          /* success */state[/* success */2],
                          /* loading : false */0
                        ],
                        (function (self) {
                            console.log("ShowErrorMessage Reducer:", text);
                            setTimeout((function () {
                                    return Curry._1(self[/* send */4], /* ClearError */3);
                                  }), 2500);
                            return /* () */0;
                          })
                      ]);
          case 2 : 
              var text$1 = action[0];
              return /* UpdateWithSideEffects */Block.__(3, [
                        /* record */[
                          /* email */"",
                          /* error */state[/* error */1],
                          /* success : Some */[text$1],
                          /* loading : false */0
                        ],
                        (function () {
                            console.log("ShowSuccessMessage Reducer:", text$1);
                            setTimeout((function () {
                                    return ReasonReact.Router[/* push */0]("/");
                                  }), 3000);
                            return /* () */0;
                          })
                      ]);
          
        }
      }
    });
  return newrecord;
}

exports.Styles = Styles;
exports.text = text;
exports.validateEmail = validateEmail;
exports.showApiError = showApiError;
exports.component = component;
exports.make = make;
/* card Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/reset.re
// module id = 110
// module chunks = 0